"use client";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { useMemo } from "react";
import "./index.css";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Ho_Chi_Minh";
const THU_VI = [
  "Chủ nhật",
  "Thứ hai",
  "Thứ ba",
  "Thứ tư",
  "Thứ năm",
  "Thứ sáu",
  "Thứ bảy",
];

const CumeoDateTabs = ({ selectedDate, onDateChange, compact }) => {
  const today = useMemo(() => dayjs().tz(TZ), []);
  const todayString = today.format("YYYY-MM-DD");

  const dateOptions = useMemo(() => {
    const options = [];

    // "Live" Option
    options.push({
      value: "live",
      label: "Live",
      dateLabel: null,
    });

    // "Today" Option
    options.push({
      value: todayString,
      label: "Hôm Nay",
      dateLabel: today.format("DD/MM"),
    });

    // Next 6 days
    for (let i = 1; i <= 6; i++) {
        const d = today.clone().add(i, "day");
        const label = i === 1 ? "Ngày Mai" : THU_VI[d.day()];
        options.push({
            value: d.format("YYYY-MM-DD"),
            label: label,
            dateLabel: d.format("DD/MM"),
        });
    }

    return options;
  }, [todayString, today]);

  const activeBgStyle = {
    background: "linear-gradient(91deg, var(--theme-gradient-start), var(--theme-gradient-end) 100.01%)",
  };

  return (
    <div className={`flex !w-full max-w-full !box-border overflow-x-hidden m-0 p-0 ${compact ? "h-full items-stretch" : "items-center mb-4 mt-2"}`}>
      <div className="cumeo-scroll-tabs flex h-full !w-full min-w-0 max-w-full !float-none gap-2 !overflow-x-auto !overflow-y-hidden scroll-smooth items-center px-1 pb-1.5 m-0 !box-border [-webkit-overflow-scrolling:touch]">
        {dateOptions.map((opt) => {
          const isSelected = selectedDate === opt.value;
          
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onDateChange(opt.value)}
              className={`flex-shrink-0 px-3 h-12 md:h-14 min-w-[72px] md:min-w-[86px] rounded-lg transition-colors duration-200 cursor-pointer border-0 outline-none m-0 box-border flex flex-col items-center justify-center gap-0.5
                ${isSelected 
                  ? "text-[var(--theme-on-primary)]" 
                  : "bg-[var(--theme-accent)] text-[var(--theme-text-muted)] hover:bg-[var(--theme-bg-hover)]"}`}
              style={isSelected ? activeBgStyle : {}}
            >
              <span className="text-sm font-bold whitespace-nowrap">{opt.label}</span>
              {opt.dateLabel && (
                  <span className={`text-xs ${isSelected ? "text-[var(--theme-on-primary)]/80" : "text-[var(--text-half-score)]"} font-medium whitespace-nowrap`}>
                      {opt.dateLabel}
                  </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CumeoDateTabs;
